import superMeta from '../_ABSTRACT/metaAbstractNode.mjs'

export default {
    ...superMeta,
    name: '业务交互功能',
    type: 'SF_1',
}
